export const troubleshootNavigation = [
  {
    title: 'SDK Guides',
    links: [
      {
        title: 'How to Update SDK',
        href: '/troubleshoot/how-to-update-sdk',
      },
      {
        title: 'GoogleAdsOnDeviceConversion (ODM)',
        href: '/troubleshoot/google-ads-on-device-conversion',
      },
      {
        title: 'Gradle Update',
        href: '/troubleshoot/gradle-update',
      },
    ],
  },
  {
    title: 'Common Issues',
    links: [
      {
        title: 'Android Build',
        links: [
          {
            title: 'Failed to Transform slf4j-api-2.0.16.jar',
            href: '/troubleshoot/failed-to-transform-slf4j-api',
          },
          {
            title: 'Enable 16KB Page Size Support',
            href: '/troubleshoot/16kb-page-size',
          },
          {
            title: 'Ad-Networks Require Gradle 8 or Higher',
            href: '/troubleshoot/build-failed-cause-ad-network',
          },
          {
            title: 'Handle the Deprecated API in Bee Library',
            href: '/troubleshoot/deprecated-bee-api',
          },
          {
            title: 'Duplicate Class (Maio SDK AAR+JAR Conflict)',
            href: '/troubleshoot/android-duplicate-class-maio',
          },
          {
            title: 'PackageAndroidArtifact Failure',
            href: '/troubleshoot/packageandroidartifact-readonly-sdk',
          },
          {
            title: 'Admob App ID Conflict',
            href: '/troubleshoot/admob-appid-conflict',
          },
          {
            title: 'NoClassDefFoundError (Ktor Conflict)',
            href: '/troubleshoot/ktor-noclassdeffounderror',
          },
        ],
      },
      {
        title: 'iOS Build',
        links: [
          {
            title: 'Firebase iOS SDK Conflicts',
            href: '/troubleshoot/firebase-ios-sdk-conflicts',
          },
          {
            title: 'Firebase Messaging (FCM) Not Working',
            href: '/troubleshoot/firebase-messaging-not-working-ios',
          },
          {
            title: 'Undefined symbol AppMetricaLibraryAdapter (Yandex)',
            href: '/troubleshoot/appmetrica-undefined-symbol',
          },
          {
            title: 'Runtime Crash — Library not loaded BigoADS.framework',
            href: '/troubleshoot/bigo-ads-library-not-loaded',
          },
          {
            title: 'Multiple Commands Produce (Duplicate XCFramework Embed)',
            href: '/troubleshoot/ios-multiple-commands-produce-xcframework',
          },
          {
            title: 'CocoaPods AppLovin SDK Version Conflict',
            href: '/troubleshoot/cocoapods-applovin-version-conflict',
          },
          {
            title: 'CocoaPods Maio GMA 13.x Conflict',
            href: '/troubleshoot/cocoapods-maio-gma-13-conflict',
          },
          {
            title: 'AdjustSignSdk Framework Not Found',
            href: '/troubleshoot/adjust-sign-sdk-framework-not-found',
          },
        ],
      },
      {
        title: 'Payment & IAP',
        links: [
          {
            title: 'Google Billing Service Not Available',
            href: '/troubleshoot/billing-service',
          },
          {
            title: 'Display Pricing Fails to Show',
            href: '/troubleshoot/display-pricing-not-showing',
          },
          {
            title: 'IAA Banner Position Reverts to Top',
            href: '/troubleshoot/iaa-banner-position-reverts-to-top',
          },
          {
            title: 'Payment Not Working on Android',
            href: '/troubleshoot/payment-not-working-on-android',
          },
          {
            title: 'Payment Not Working on iOS',
            href: '/troubleshoot/payment-not-working-on-ios',
          },
          {
            title: 'Race Condition after OnPurchaseDone',
            href: '/troubleshoot/race-condition-after-onpurchasedone',
          },
        ],
      },
      {
        title: 'Tracker',
        links: [
          {
            title: '[iOS] Adjust events are not tracked at all',
            href: '/troubleshoot/adjust-events-not-tracked-ios',
          },
        ],
      },
    ],
  },
  {
    title: 'Console Migration',
    links: [
      {
        title: 'Migrating Apple IAP to a New Developer Console',
        href: '/troubleshoot/apple-console-migration',
      },
    ],
  },
  {
    title: 'Integration Help',
    links: [
      {
        title: 'Getting Help',
        href: '/troubleshoot/getting-help',
      },
    ],
  },
]
